import { Link } from "react-router-dom";
import {useNavigate} from "react-router-dom";
const  Ad = ({creator,image,stats,chunk,id}) => {
    const navigate=useNavigate();
    const engage=()=>{
        localStorage.setItem("ad",chunk);
        navigate("/dashboard/marketplace/resource")
    }
    return (  
        <div className="ad" key={id}>
            <strong className="creator_name color-primary">{creator}</strong>
            <img src={`${image}`} alt="" />
            <div className="ad-bottom">
                <h1 className="color-primary">{stats}</h1>
                <strong className="color-typo">{stats > 1 ? ` engagements` : `engagement`}</strong>
               <button onClick={engage}>Engage</button>
            </div>
        </div>
 );
}
 
export default Ad;